export default "__VITE_ASSET__fb2f501f__"